import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./auth/AuthProvider";
import { AuthCallback } from "./auth/AuthCallback";
import { ProtectedRoute } from "./auth/ProtectedRoute";
import { AuthenticatedShell } from "./components/shell/AuthenticatedShell";
import { ComponentsPage } from "./pages/ComponentsPage";
import { DashboardPage } from "./pages/DashboardPage";
import { HomePage } from "./pages/HomePage";
import { LayoutPage } from "./pages/LayoutPage";
import { ProjectDetailPage } from "./pages/ProjectDetailPage";
import { ProjectsListPage } from "./pages/ProjectsListPage";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster richColors position="bottom-right" />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <AuthenticatedShell>
                    <DashboardPage />
                  </AuthenticatedShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects"
              element={
                <ProtectedRoute>
                  <AuthenticatedShell>
                    <ProjectsListPage />
                  </AuthenticatedShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/:id"
              element={
                <ProtectedRoute>
                  <AuthenticatedShell>
                    <ProjectDetailPage />
                  </AuthenticatedShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/:id/components"
              element={
                <ProtectedRoute>
                  <AuthenticatedShell>
                    <ComponentsPage />
                  </AuthenticatedShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/:projectId/layout/:runId"
              element={
                <ProtectedRoute>
                  <LayoutPage />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
